import { baseCommand } from "./basecommand";

type lightSettingTypename = "light_setting";
type lightSettingdatatype = {
    "intensity" : number;
    "temperature" : number;
}

type pscommand<T> = {
    "type": T extends lightSettingTypename ? T : never;
    "data": T extends lightSettingTypename ? lightSettingdatatype : never;
};

export type lightSettingmCommand = pscommand<lightSettingTypename>;

export class lightSetting extends baseCommand {
    private type: lightSettingTypename = "light_setting";

    // intensity: ライト強度　0-1.0 float
    private intensity: number = 0.5;
    // temperature: 色温度　2000～8000のint
    private temperature: number = 5000;

    constructor() {
        super();
    }

    public setLight(intensity: number, temperature: number) {
        this.intensity = intensity;
        this.temperature = temperature;
    }

    public object(): lightSettingmCommand {
      return {
          "type": this.type,
          "data": {
            "intensity": this.intensity,
            "temperature": this.temperature
          }
      }
    }
}
